"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearPromotionsOptOptEnum = exports.EnrollmentHelperApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 *
 */
class EnrollmentHelperApi extends runtime.BaseAPI {
    /**
     * Get normalized address suggestions based upon an applicant-provided address
     */
    async addressSuggestionsRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling addressSuggestions.');
        }
        if (requestParameters.address === null || requestParameters.address === undefined) {
            throw new runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling addressSuggestions.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/address-suggestions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.AddressToJSON(requestParameters.address),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.AddressFromJSON));
    }
    /**
     * Get normalized address suggestions based upon an applicant-provided address
     */
    async addressSuggestions(requestParameters) {
        const response = await this.addressSuggestionsRaw(requestParameters);
        return await response.value();
    }
    /**
     * Look up applicant contact info/preferences by biographics
     */
    async applicantInfoByBiographicsRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling applicantInfoByBiographics.');
        }
        if (requestParameters.biographicsLookup === null || requestParameters.biographicsLookup === undefined) {
            throw new runtime.RequiredError('biographicsLookup', 'Required parameter requestParameters.biographicsLookup was null or undefined when calling applicantInfoByBiographics.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/applicant-info`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.BiographicsLookupToJSON(requestParameters.biographicsLookup),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ApplicantInfoQueryFromJSON(jsonValue));
    }
    /**
     * Look up applicant contact info/preferences by biographics
     */
    async applicantInfoByBiographics(requestParameters) {
        const response = await this.applicantInfoByBiographicsRaw(requestParameters);
        return await response.value();
    }
    /**
     * Cancels all appointments active for an enrollment.
     */
    async appointmentCancelRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling appointmentCancel.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling appointmentCancel.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/appointment/{enrollmentId}/cancel`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Cancels all appointments active for an enrollment.
     */
    async appointmentCancel(requestParameters) {
        await this.appointmentCancelRaw(requestParameters);
    }
    /**
     * Cancels all appointments active for an enrollment.
     */
    async appointmentCancel_1Raw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling appointmentCancel_1.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling appointmentCancel_1.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/public/appointment/{enrollmentId}/cancel`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Cancels all appointments active for an enrollment.
     */
    async appointmentCancel_1(requestParameters) {
        await this.appointmentCancel_1Raw(requestParameters);
    }
    /**
     * Opt in/out to CLEAR promotions
     */
    async clearPromotionsOptRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling clearPromotionsOpt.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling clearPromotionsOpt.');
        }
        if (requestParameters.opt === null || requestParameters.opt === undefined) {
            throw new runtime.RequiredError('opt', 'Required parameter requestParameters.opt was null or undefined when calling clearPromotionsOpt.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/clear-promotions/enrollment/{enrollmentId}/opt/{opt}`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))).replace(`{${"opt"}}`, encodeURIComponent(String(requestParameters.opt))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.ClearPromotionFormToJSON(requestParameters.clearPromotionForm),
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Opt in/out to CLEAR promotions
     */
    async clearPromotionsOpt(requestParameters) {
        await this.clearPromotionsOptRaw(requestParameters);
    }
    /**
     * Search for applicants by e-mail address or phone number
     */
    async findApplicantsByEmailOrPhoneRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling findApplicantsByEmailOrPhone.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/applicant-search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.ApplicantSearchFormToJSON(requestParameters.applicantSearchForm),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.FindApplicantsByEmailOrPhoneItemFromJSON));
    }
    /**
     * Search for applicants by e-mail address or phone number
     */
    async findApplicantsByEmailOrPhone(requestParameters) {
        const response = await this.findApplicantsByEmailOrPhoneRaw(requestParameters);
        return await response.value();
    }
    /**
     * Look up KTN by Application ID
     */
    async ktnLookupByApplicationIdRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling ktnLookupByApplicationId.');
        }
        if (requestParameters.applicationIdLookup === null || requestParameters.applicationIdLookup === undefined) {
            throw new runtime.RequiredError('applicationIdLookup', 'Required parameter requestParameters.applicationIdLookup was null or undefined when calling ktnLookupByApplicationId.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/ktn-lookup/application-id`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.ApplicationIdLookupToJSON(requestParameters.applicationIdLookup),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.KTNDetailsFromJSON(jsonValue));
    }
    /**
     * Look up KTN by Application ID
     */
    async ktnLookupByApplicationId(requestParameters) {
        const response = await this.ktnLookupByApplicationIdRaw(requestParameters);
        return await response.value();
    }
    /**
     * Look up KTN by biographics
     */
    async ktnLookupByBiographicsRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling ktnLookupByBiographics.');
        }
        if (requestParameters.biographicsLookup === null || requestParameters.biographicsLookup === undefined) {
            throw new runtime.RequiredError('biographicsLookup', 'Required parameter requestParameters.biographicsLookup was null or undefined when calling ktnLookupByBiographics.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/ktn-lookup/biographics`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.BiographicsLookupToJSON(requestParameters.biographicsLookup),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.KTNDetailsFromJSON(jsonValue));
    }
    /**
     * Look up KTN by biographics
     */
    async ktnLookupByBiographics(requestParameters) {
        const response = await this.ktnLookupByBiographicsRaw(requestParameters);
        return await response.value();
    }
    /**
     * Validate OTP challenge for Application Status Lookup
     */
    async optAppstatusChallengeRaw(requestParameters) {
        if (requestParameters.otpSessionId === null || requestParameters.otpSessionId === undefined) {
            throw new runtime.RequiredError('otpSessionId', 'Required parameter requestParameters.otpSessionId was null or undefined when calling optAppstatusChallenge.');
        }
        if (requestParameters.otpCode === null || requestParameters.otpCode === undefined) {
            throw new runtime.RequiredError('otpCode', 'Required parameter requestParameters.otpCode was null or undefined when calling optAppstatusChallenge.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling optAppstatusChallenge.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        const response = await this.request({
            path: `/public/otp_appstatus_challenge/session/{otpSessionId}/code/{otpCode}`.replace(`{${"otpSessionId"}}`, encodeURIComponent(String(requestParameters.otpSessionId))).replace(`{${"otpCode"}}`, encodeURIComponent(String(requestParameters.otpCode))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Validate OTP challenge for Application Status Lookup
     */
    async optAppstatusChallenge(requestParameters) {
        await this.optAppstatusChallengeRaw(requestParameters);
    }
    /**
     * Lookup KTN Details for challenge verified OTP
     */
    async optKtndetailsSessionRaw(requestParameters) {
        if (requestParameters.otpSessionId === null || requestParameters.otpSessionId === undefined) {
            throw new runtime.RequiredError('otpSessionId', 'Required parameter requestParameters.otpSessionId was null or undefined when calling optKtndetailsSession.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling optKtndetailsSession.');
        }
        if (requestParameters.biographicsLookup === null || requestParameters.biographicsLookup === undefined) {
            throw new runtime.RequiredError('biographicsLookup', 'Required parameter requestParameters.biographicsLookup was null or undefined when calling optKtndetailsSession.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        const response = await this.request({
            path: `/public/updated-ktn-lookup/session/{otpSessionId}`.replace(`{${"otpSessionId"}}`, encodeURIComponent(String(requestParameters.otpSessionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.BiographicsLookupToJSON(requestParameters.biographicsLookup),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.KTNDetailsFromJSON(jsonValue));
    }
    /**
     * Lookup KTN Details for challenge verified OTP
     */
    async optKtndetailsSession(requestParameters) {
        const response = await this.optKtndetailsSessionRaw(requestParameters);
        return await response.value();
    }
    /**
     * OTP with user-provided email and/or phone. This is used when we do not have the enrollment or KTN and need to collect the communication method(s)
     */
    async otpKtndetailsRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling otpKtndetails.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        const response = await this.request({
            path: `/public/updated-ktn-lookup/session`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.OtpFormToJSON(requestParameters.otpForm),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.OtpResponseFromJSON(jsonValue));
    }
    /**
     * OTP with user-provided email and/or phone. This is used when we do not have the enrollment or KTN and need to collect the communication method(s)
     */
    async otpKtndetails(requestParameters) {
        const response = await this.otpKtndetailsRaw(requestParameters);
        return await response.value();
    }
    /**
     * Search for renewal eligibility by ktn or biographics
     */
    async searchEligibilityByKtnOrBiographicsRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling searchEligibilityByKtnOrBiographics.');
        }
        if (requestParameters.eligibilityLookup === null || requestParameters.eligibilityLookup === undefined) {
            throw new runtime.RequiredError('eligibilityLookup', 'Required parameter requestParameters.eligibilityLookup was null or undefined when calling searchEligibilityByKtnOrBiographics.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/search/eligibility`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.EligibilityLookupToJSON(requestParameters.eligibilityLookup),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentCreatedFromJSON(jsonValue));
    }
    /**
     * Search for renewal eligibility by ktn or biographics
     */
    async searchEligibilityByKtnOrBiographics(requestParameters) {
        const response = await this.searchEligibilityByKtnOrBiographicsRaw(requestParameters);
        return await response.value();
    }
    /**
     * Searches for the existence of an enrollment in CLEAR and the TIM systems
     */
    async searchExistenceByBiographicsRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling searchExistenceByBiographics.');
        }
        if (requestParameters.biographicsLookup === null || requestParameters.biographicsLookup === undefined) {
            throw new runtime.RequiredError('biographicsLookup', 'Required parameter requestParameters.biographicsLookup was null or undefined when calling searchExistenceByBiographics.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/search/existence/biographics`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.BiographicsLookupToJSON(requestParameters.biographicsLookup),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ExistenceStatusFromJSON(jsonValue));
    }
    /**
     * Searches for the existence of an enrollment in CLEAR and the TIM systems
     */
    async searchExistenceByBiographics(requestParameters) {
        const response = await this.searchExistenceByBiographicsRaw(requestParameters);
        return await response.value();
    }
    /**
     * Look up applicant status (My Status) by Application ID
     */
    async statusLookupByApplicationIdRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling statusLookupByApplicationId.');
        }
        if (requestParameters.applicationIdLookup === null || requestParameters.applicationIdLookup === undefined) {
            throw new runtime.RequiredError('applicationIdLookup', 'Required parameter requestParameters.applicationIdLookup was null or undefined when calling statusLookupByApplicationId.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/applicant-status/application-id`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.ApplicationIdLookupToJSON(requestParameters.applicationIdLookup),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ApplicantStatusDetailsFromJSON(jsonValue));
    }
    /**
     * Look up applicant status (My Status) by Application ID
     */
    async statusLookupByApplicationId(requestParameters) {
        const response = await this.statusLookupByApplicationIdRaw(requestParameters);
        return await response.value();
    }
    /**
     * Look up applicant status (My Status) by Biographics
     */
    async statusLookupByBiographicsRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling statusLookupByBiographics.');
        }
        if (requestParameters.biographicsLookup === null || requestParameters.biographicsLookup === undefined) {
            throw new runtime.RequiredError('biographicsLookup', 'Required parameter requestParameters.biographicsLookup was null or undefined when calling statusLookupByBiographics.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/applicant-status/biographics`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.BiographicsLookupToJSON(requestParameters.biographicsLookup),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ApplicantStatusDetailsFromJSON(jsonValue));
    }
    /**
     * Look up applicant status (My Status) by Biographics
     */
    async statusLookupByBiographics(requestParameters) {
        const response = await this.statusLookupByBiographicsRaw(requestParameters);
        return await response.value();
    }
    /**
     * Look up applicant long status code by phone number
     */
    async statusLookupByPhoneNumberRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling statusLookupByPhoneNumber.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling statusLookupByPhoneNumber.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/applicant-status/phone-number`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Look up applicant long status code by phone number
     */
    async statusLookupByPhoneNumber(requestParameters) {
        const response = await this.statusLookupByPhoneNumberRaw(requestParameters);
        return await response.value();
    }
    /**
     * Update applicant contact info/preferences
     */
    async updateApplicantInfoRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling updateApplicantInfo.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling updateApplicantInfo.');
        }
        if (requestParameters.applicantInfoCommand === null || requestParameters.applicantInfoCommand === undefined) {
            throw new runtime.RequiredError('applicantInfoCommand', 'Required parameter requestParameters.applicantInfoCommand was null or undefined when calling updateApplicantInfo.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/applicant-info/enrollment/{enrollmentId}`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.ApplicantInfoCommandToJSON(requestParameters.applicantInfoCommand),
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Update applicant contact info/preferences
     */
    async updateApplicantInfo(requestParameters) {
        await this.updateApplicantInfoRaw(requestParameters);
    }
    /**
     * Updated endpoint to generate OTP for application status lookup by biographics
     */
    async updatedAppStatusLookupBiographicRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling updatedAppStatusLookupBiographic.');
        }
        if (requestParameters.biographicsLookup === null || requestParameters.biographicsLookup === undefined) {
            throw new runtime.RequiredError('biographicsLookup', 'Required parameter requestParameters.biographicsLookup was null or undefined when calling updatedAppStatusLookupBiographic.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/public/updated-applicant-status/biographics`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.BiographicsLookupToJSON(requestParameters.biographicsLookup),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.OtpResponseFromJSON(jsonValue));
    }
    /**
     * Updated endpoint to generate OTP for application status lookup by biographics
     */
    async updatedAppStatusLookupBiographic(requestParameters) {
        const response = await this.updatedAppStatusLookupBiographicRaw(requestParameters);
        return await response.value();
    }
    /**
     * Updated endpoint to lookup Applicant Status for verified OTP
     */
    async updatedAppStatusLookupSessionRaw(requestParameters) {
        if (requestParameters.otpSessionId === null || requestParameters.otpSessionId === undefined) {
            throw new runtime.RequiredError('otpSessionId', 'Required parameter requestParameters.otpSessionId was null or undefined when calling updatedAppStatusLookupSession.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling updatedAppStatusLookupSession.');
        }
        if (requestParameters.biographicsLookup === null || requestParameters.biographicsLookup === undefined) {
            throw new runtime.RequiredError('biographicsLookup', 'Required parameter requestParameters.biographicsLookup was null or undefined when calling updatedAppStatusLookupSession.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        const response = await this.request({
            path: `/public/updated-applicant-status/session/{otpSessionId}`.replace(`{${"otpSessionId"}}`, encodeURIComponent(String(requestParameters.otpSessionId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.BiographicsLookupToJSON(requestParameters.biographicsLookup),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ApplicantStatusDetailsFromJSON(jsonValue));
    }
    /**
     * Updated endpoint to lookup Applicant Status for verified OTP
     */
    async updatedAppStatusLookupSession(requestParameters) {
        const response = await this.updatedAppStatusLookupSessionRaw(requestParameters);
        return await response.value();
    }
    /**
     * Updated endpoint to generate OTP for KTN details lookup by biographics
     */
    async updatedKtndetailsLookupRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling updatedKtndetailsLookup.');
        }
        if (requestParameters.biographicsLookup === null || requestParameters.biographicsLookup === undefined) {
            throw new runtime.RequiredError('biographicsLookup', 'Required parameter requestParameters.biographicsLookup was null or undefined when calling updatedKtndetailsLookup.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        const response = await this.request({
            path: `/public/updated-ktn-lookup/biographics`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.BiographicsLookupToJSON(requestParameters.biographicsLookup),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.OtpResponseFromJSON(jsonValue));
    }
    /**
     * Updated endpoint to generate OTP for KTN details lookup by biographics
     */
    async updatedKtndetailsLookup(requestParameters) {
        const response = await this.updatedKtndetailsLookupRaw(requestParameters);
        return await response.value();
    }
}
exports.EnrollmentHelperApi = EnrollmentHelperApi;
/**
    * @export
    * @enum {string}
    */
var ClearPromotionsOptOptEnum;
(function (ClearPromotionsOptOptEnum) {
    ClearPromotionsOptOptEnum["In"] = "in";
    ClearPromotionsOptOptEnum["Out"] = "out";
})(ClearPromotionsOptOptEnum = exports.ClearPromotionsOptOptEnum || (exports.ClearPromotionsOptOptEnum = {}));
//# sourceMappingURL=EnrollmentHelperApi.js.map